import type { CSSProperties } from 'react';
import { type ReleaseRow } from '../../lib/admin';

const PROFILE_COLOR: Record<ReleaseRow['profile'], string> = {
  production: 'var(--naia-green-bg)',
  preview: 'var(--naia-sky)',
  development: 'var(--naia-card-alt)',
};
function profileLabel(p: ReleaseRow['profile']): string {
  return p === 'production' ? 'PROD' : p === 'development' ? 'DEV' : 'PREVIEW';
}

const gridClass = "grid grid-cols-[70px_minmax(0,1fr)_90px_130px_60px] gap-2 p-[6px_10px]";

/* Admin dashboard: every APK ever published to the release registry. */
/* Presentational — data comes from the parent. Extracted from Admin.tsx (NAI-207). */
export function ReleasesTable({ releases }: { releases: ReleaseRow[] }) {
  return (
    <div className="border border-border rounded-[12px] overflow-hidden bg-card">
      <div className={`${gridClass} text-[10px] font-black tracking-[0.6px] text-muted-foreground bg-naia-card-alt border-b border-border`}>
        <span>PROFIL</span>
        <span>BUILD ID · VERSION · NOTES</span>
        <span>PLATFORM</span>
        <span>DATE</span>
        <span className="text-right">APK</span>
      </div>
      {releases.length === 0 ? (
        <p className="p-3 text-muted-foreground text-[13px]">Aucune release enregistrée.</p>
      ) : (
        releases.map((r) => (
          <div key={r.id} className={`${gridClass} border-b border-naia-line-soft items-center text-[12px]`}>
            <span
              className="text-[10px] font-black bg-[var(--profile-bg,var(--naia-card-alt))] text-foreground border border-border rounded-[8px] p-[2px_6px] text-center tracking-[0.4px] justify-self-start"
              style={{ '--profile-bg': PROFILE_COLOR[r.profile] } as CSSProperties}
            >
              {profileLabel(r.profile)}
            </span>
            <div className="min-w-0">
              <div className="font-mono text-[11px] text-muted-foreground overflow-hidden text-ellipsis whitespace-nowrap">{r.build_id ?? '—'} · v{r.version}</div>
              {r.notes && <div className="text-[11px] text-foreground overflow-hidden text-ellipsis whitespace-nowrap">{r.notes}</div>}
            </div>
            <span className="text-[11px] font-mono">{r.platform}</span>
            <span className="text-[11px] font-mono text-muted-foreground">
              {new Date(r.created_at).toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short' })}
            </span>
            <a href={r.url} target="_blank" rel="noopener" className="justify-self-end p-[4px_10px] bg-naia-blue border-none rounded-sm font-extrabold text-[11px] text-card">↓</a>
          </div>
        ))
      )}
    </div>
  );
}
